module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("THE FIRST FISH I EVER CAUGHT ON A FLY ROD")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("was a bluegill when I was 10 years old. I had no idea what I was doing, but somehow that summer afternoon, one of my wild flails got a little Wooly Bugger—one of six flies I owned—just far enough off the bank to get eaten. I was instantly in love with flyfishing, and 22 years later, I’ve come to realize that no matter your skill level, the excitement of a hooking a fish on fly mirrors the first time again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I believe that’s because flyfishing makes you think. Every aspect—from where you stand, to how your fly lands, to how you’ll fight a fish—requires calculation. Is it more work than casting and retrieving a lure? Absolutely, but it’s this challenge that makes every fish caught on fly a little sweeter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What I don’t believe is that flyfishing is superior to any other form of the sport. To me, a fly rod is another tool in my arsenal, and just as a good golfer needs to know how to putt and drive, all anglers should have a basic understanding of flyfishing. Fish long enough and I guarantee a scenario will arise when a well-presented fly will hook a fish faster than any lure or bait. And whether you are a life-long flycaster or thinking about buying your first outfit, I promise this book will ready you for any situation you face with a fly rod in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JOE CERMELE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fishing Editor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Field & Stream")])])])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ef38cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap00b.vue
// module id = 69
// module chunks = 0